import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Heading } from '@lomarengas/design-system';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { fi } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';
import { navigate } from '@storybook/addon-links';
import {
  BookingType,
  bookingTypeTranslations,
} from '../Constants/BookingTypeEnum';

import {
  addAddOnToBookingContainerAsync,
  AddAddOnToBookingContainerItem,
  BookingContainer,
  BookingContainerUpdateItem,
  BookingDetailsData,
  BookingDetailsNoteItem,
  BookingDetailsOrderItem,
  CancelBooking,
  cancelBookingAsync,
  ClearContainerAsync,
  ClearContainerItem,
  confirmBookingAsync,
  CreateBookingNote,
  getBookingContainerDetailsAsync,
  getSelectableAddOnsAsync,
  removeFromBookingContainerAsync,
  RemoveFromBookingContainerItem,
  saveOwnerOwnBookingAsync,
  selectBasketBookingContainer,
  setWebShopCustomerState,
  TravelAgencyData,
  updateBookingContainerAsync,
  UpdateBookingToPreliminary,
  UpdateBookingToPreliminaryAsync,
  WebShopCustomerItem,
} from '../bookingsSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { BillingLocales } from '../Constants/BillingLocales';
import {
  AccountDetailsFromDb,
  getAcountDetailsFromDbAsync,
} from '../../Users/identityUsersSlice';
import { addStatusToast, Loader } from '../../../common/components';
import { OwnerOwnBooking, OwnerOwnBookingNote } from '../OwnerOwnInterfaces';

export interface BooleanProps {
  showNewBookingModal;
  setShowNewBookingModal;
  editedBooking: BookingDetailsData;
  setEditedBooking;
  setBookingContainer;
  setBasketContainer;
  webshopCustomer;
  bookingTypeParam: number;
}

export interface SelectableAddOnFilter {
  accommodationId: string;
  units: number;
  adults: number;
  childs: number;
  includeNonVisible: boolean;
}

export const NewBookingModal: React.FC<BooleanProps> = ({
  showNewBookingModal,
  setShowNewBookingModal,
  editedBooking,
  setEditedBooking,
  setBookingContainer,
  setBasketContainer,
  webshopCustomer,
  bookingTypeParam,
  ...props
}) => {
  const { t } = useTranslation(['common', 'travelAgencyBookingModal']);
  const textAreaRefs = useRef([]);
  const ownertextAreaRefs = useRef([]);
  const officertextAreaRefs = useRef([]);

  const history = useNavigate();
  const dispatch = useAppDispatch();
  const selectableAddOns = useAppSelector(
    state => state.bookings.selectableAddOns,
  );
  const initFetch = useCallback(() => {}, [dispatch]);

  const [editedBookingLocal, setEditedBookingLocal] =
    useState<BookingDetailsData>(editedBooking);

  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
  const [showDueDateConfirmation, setShowDueDateConfirmation] = useState(false);
  const [isAvailCheckActive, setIsAvailCheckActive] = useState(false);
  const [globalStartDate, setGlobalStartDate] = useState(null);
  const [globalEndDate, setGlobalEndDate] = useState(null);
  const basketContainer = useAppSelector(selectBasketBookingContainer);

  const handleCancelClose = useCallback(() => {
    if (
      editedBookingLocal &&
      editedBookingLocal.bookingType === 0 &&
      (editedBookingLocal.preliminaryBookingDueDate === null ||
        editedBookingLocal.preliminaryBookingDueDate === undefined)
    ) {
      const editedBookingLocalStore = {
        ...editedBookingLocal,
        errors: ['Alustavan varauksen voimassaolo puuttuu !'],
      };
      setEditedBookingLocal(editedBookingLocalStore);
      setShowDueDateConfirmation(true);
      return;
    }
    setShowCloseConfirmation(false);
  }, []);
  useEffect(() => {}, [basketContainer]);
  const handleSetDueDateClose = useCallback(() => {
    setShowDueDateConfirmation(false);
  }, []);
  const initialBookingContainer: BookingContainer = {
    id: '',
    bookingContainerStatus: 0,
    bookingResponses: [],
    advancePaid: false,
    acceptMarketing: false,
    acceptCancelInsuranceTerms: false,
    acceptBookingTerms: false,
    siteId: '',
    adults: 0,
    childs: 0,
    containerTotal: 0,
    containerTravelTotal: 0,
  };

  const handleJustClose = useCallback((localedited?: BookingDetailsData) => {
    dispatch(getBookingContainerDetailsAsync(localedited.id));
    if (
      localedited &&
      localedited.bookingType === 0 &&
      (localedited.preliminaryBookingDueDate === null ||
        localedited.preliminaryBookingDueDate === undefined)
    ) {
      if (
        localedited &&
        localedited.extraBookingResponses &&
        localedited.extraBookingResponses[0]
      ) {
        history(`/bookings/${localedited.extraBookingResponses[0].id}`);
      } else {
        history(`/`);
      }
      setShowNewBookingModal(false);
    }
    if (
      localedited &&
      localedited.extraBookingResponses &&
      localedited.extraBookingResponses[0]
    ) {
      const clearCommand = {
        bookingContainerId: localedited.bookingContainerId ?? '',
      } as ClearContainerItem;
      dispatch(ClearContainerAsync(clearCommand)).then(() => {
        dispatch(setBasketContainer(initialBookingContainer));
      });
      history(`/bookings/${localedited.extraBookingResponses[0].id}`);
    } else if (
      basketContainer !== null &&
      basketContainer.bookingResponses !== null &&
      basketContainer.bookingResponses.filter(
        br => br.bookingType === 0 && br.payerId === null,
      )
    ) {
      history(`/bookings/bookingcontainer/newContainer`);
    } else {
      history(`/`);
    }
    setShowNewBookingModal(false);
  }, []);
  const handleConfirmClose = useCallback(() => {
    setShowCloseConfirmation(false);
    setShowNewBookingModal(false);
    dispatch(
      cancelBookingAsync({
        bookingId: editedBooking.id,
        reasonOfCancellation: 'Ei Maksajaa',
        expectedBookingType: editedBooking?.bookingType,
      } as CancelBooking),
    ).then(res => {
      dispatch(setBasketContainer(null)).then(res2 => {
        if (res2.meta.requestStatus === 'fulfilled') {
          // dispatch(getBookingContainerDetailsAsync(editedBooking.id));
          history(`/bookings/search-accommodations`, {});
        }
      });
    });
  }, [setShowNewBookingModal, editedBooking, editedBookingLocal]);
  const handleShowCloseConfirmation = useCallback(
    (localedited?: BookingDetailsData) => {
      dispatch(getBookingContainerDetailsAsync(localedited.id));
      setShowCloseConfirmation(true);
    },
    [],
  );
  const [editedCustomerBookingNotes, setEditedCustomerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.customerBookingNotes !== null &&
      editedBookingLocal.customerBookingNotes !== undefined
      ? editedBookingLocal.customerBookingNotes
      : [],
  );

  const [editedOwnerBookingNotes, setEditedOwnerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.ownerBookingNotes !== null &&
      editedBookingLocal.ownerBookingNotes !== undefined
      ? editedBookingLocal.ownerBookingNotes
      : [],
  );
  const [editedOfficerBookingNotes, setEditedOfficerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.officerBookingNotes !== null &&
      editedBookingLocal.officerBookingNotes !== undefined
      ? editedBookingLocal.officerBookingNotes
      : [],
  );
  const [linenChecked, setLinenChecked] = useState(false);
  const [showLoader, setshowLoader] = useState<boolean>(false);
  const [cleaningChecked, setCleaningChecked] = useState(false);
  const [ownerOwnBookingType, setOwnerOwnBookingType] = useState('OwnerOwn');

  const [editedSelectableAddOns, seteditedSelectableAddOns] =
    useState<BookingDetailsOrderItem[]>(selectableAddOns);

  const [makingOwnerBooking, setMakingOwnerBooking] = useState<boolean>(false);

  const [selectedPayer, setSelectedPayer] =
    useState<AccountDetailsFromDb>(null);
  function handleCloseBooking() {
    setShowNewBookingModal(false);
    if (
      !basketContainer.bookingResponses ||
      basketContainer.bookingResponses.length === 0
    ) {
      history('/');
    }
  }

  function handleCloseBookingOwner() {
    setShowNewBookingModal(false);
    if (
      !basketContainer.bookingResponses ||
      basketContainer.bookingResponses.length === 0
    ) {
      history('/');
    }
  }
  const checkPayerData = () => {
    if (selectedPayer && webshopCustomer) {
      let error = false;
      if (
        selectedPayer.firstName &&
        webshopCustomer.firstName &&
        selectedPayer.firstName !== webshopCustomer.firstName
      ) {
        error = true;
      }
      if (
        selectedPayer.lastName &&
        webshopCustomer.lastName &&
        selectedPayer.lastName !== webshopCustomer.lastName
      ) {
        error = true;
      }
      if (
        selectedPayer.phones &&
        selectedPayer.phones[0] &&
        selectedPayer.phones[0].phoneNumber &&
        webshopCustomer.phoneNumber &&
        selectedPayer.phones[0].phoneNumber !== webshopCustomer.phoneNumber &&
        selectedPayer.phones[0].phoneNumber !== webshopCustomer.mobileNumber
      ) {
        error = true;
      }
      if (
        selectedPayer.emails &&
        selectedPayer.emails[0] &&
        selectedPayer.emails[0].emailAddress &&
        webshopCustomer.email &&
        selectedPayer.emails[0].emailAddress !== webshopCustomer.email
      ) {
        error = true;
      }
      if (
        selectedPayer.addresses &&
        selectedPayer.addresses[0] &&
        selectedPayer.addresses[0].postStreetAddress &&
        webshopCustomer.streetAddress &&
        selectedPayer.addresses[0].postStreetAddress !==
          webshopCustomer.streetAddress
      ) {
        error = true;
      }
      if (
        selectedPayer.addresses &&
        selectedPayer.addresses[0] &&
        selectedPayer.addresses[0].postCode &&
        webshopCustomer.postalCode &&
        selectedPayer.addresses[0].postCode !== webshopCustomer.postalCode
      ) {
        error = true;
      }
      if (
        selectedPayer.addresses &&
        selectedPayer.addresses[0] &&
        selectedPayer.addresses[0].postCity &&
        webshopCustomer.postCity &&
        selectedPayer.addresses[0].postCity !== webshopCustomer.postCity
      ) {
        error = true;
      }
      return error;
    }
    return false;
  };
  const getAdvanceValueToShow = () => {
    let valueToShow = null as number;
    if (
      editedBookingLocal.overrideAdvanceBillPrice !== null &&
      editedBookingLocal.overrideAdvanceBillPrice !== undefined &&
      editedBookingLocal.overrideAdvanceBillPrice !==
        editedBookingLocal.advanceBillPrice
    ) {
      valueToShow = editedBookingLocal.overrideAdvanceBillPrice;
    } else if (editedBookingLocal.advanceBillPrice > 0) {
      valueToShow = editedBookingLocal.advanceBillPrice;
    }
    return valueToShow;
  };
  function updateBookingContainerAndClose() {
    if (editedBookingLocal === null) {
      return;
    }
    if (
      editedBookingLocal &&
      editedBookingLocal.bookingType === 0 &&
      (editedBookingLocal.preliminaryBookingDueDate === null ||
        editedBookingLocal.preliminaryBookingDueDate === undefined)
    ) {
      const editedBookingLocalStore = {
        ...editedBookingLocal,
        errors: ['Alustavan varauksen voimassaolo puuttuu !'],
      };
      setEditedBookingLocal(editedBookingLocalStore);
      setShowDueDateConfirmation(true);
      return;
    }
    let container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBooking !== null && editedBooking.travelAgencyData != null) {
      const storedBooking = {
        ...editedBooking,
        travelAgencyData: {
          finalClientFirstName:
            editedBookingLocal.travelAgencyData.finalClientFirstName ?? '',
          finalClientLastName:
            editedBookingLocal.travelAgencyData.finalClientLastName ?? '',
          finalClientCompany:
            editedBookingLocal.travelAgencyData.finalClientCompany ?? '',
          finalClientStreetAddress:
            editedBookingLocal.travelAgencyData.finalClientStreetAddress ?? '',
          finalClientZipCode:
            editedBookingLocal.travelAgencyData.finalClientZipCode ?? '',
          finalClientCity:
            editedBookingLocal.travelAgencyData.finalClientCity ?? '',
          finalClientCountry:
            editedBookingLocal.travelAgencyData.finalClientCountry ?? '',
          finalClientEmail:
            editedBookingLocal.travelAgencyData.finalClientEmail ?? '',
          finalClientPhone:
            editedBookingLocal.travelAgencyData.finalClientPhone ?? '',
        } as TravelAgencyData,
      };
      container = { ...container, bookings: [storedBooking] };
    }
    if (editedBooking !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
              // const filteredBookingResponses =
              //   basketContainer.bookingResponses.filter(
              //     booking => booking.id !== editedBookingLocal.id,
              //   );
              // // Update the basketContainer with filtered responses
              // const updatedBasketContainer = {
              //   ...basketContainer,
              //   bookingResponses: filteredBookingResponses,
              // };
              dispatch(setBasketContainer(null));
              setShowNewBookingModal(false);
              history(`/bookings/${findItem[0].id}`);
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            console.debug(
              'Error updating booking container',
              res.payload.result.errors,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: 'Virhe',
              }),
            );
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    } else {
      setShowNewBookingModal(false);
    }
  }
  function updateBookingContainer() {
    if (editedBookingLocal === null) {
      return;
    }
    if (
      editedBookingLocal &&
      editedBookingLocal.bookingType === 0 &&
      (editedBookingLocal.preliminaryBookingDueDate === null ||
        editedBookingLocal.preliminaryBookingDueDate === undefined)
    ) {
      const editedBookingLocalStore = {
        ...editedBookingLocal,
        errors: ['Alustavan varauksen voimassaolo puuttuu !'],
      };
      setEditedBookingLocal(editedBookingLocalStore);
      return;
    }
    let container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBooking !== null && editedBooking.travelAgencyData != null) {
      const storedBooking = {
        ...editedBooking,
        travelAgencyData: {
          finalClientFirstName:
            editedBookingLocal.travelAgencyData.finalClientFirstName ?? '',
          finalClientLastName:
            editedBookingLocal.travelAgencyData.finalClientLastName ?? '',
          finalClientCompany:
            editedBookingLocal.travelAgencyData.finalClientCompany ?? '',
          finalClientStreetAddress:
            editedBookingLocal.travelAgencyData.finalClientStreetAddress ?? '',
          finalClientZipCode:
            editedBookingLocal.travelAgencyData.finalClientZipCode ?? '',
          finalClientCity:
            editedBookingLocal.travelAgencyData.finalClientCity ?? '',
          finalClientCountry:
            editedBookingLocal.travelAgencyData.finalClientCountry ?? '',
          finalClientEmail:
            editedBookingLocal.travelAgencyData.finalClientEmail ?? '',
          finalClientPhone:
            editedBookingLocal.travelAgencyData.finalClientPhone ?? '',
        } as TravelAgencyData,
      };
      container = { ...container, bookings: [storedBooking] };
    }
    if (editedBooking !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          console.debug('details updateBookingContainer', res);
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: 'Virhe',
              }),
            );
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }
  function updateBookingContainerWithData(newBooking, value) {
    if (editedBookingLocal === null) {
      return;
    }
    if (newBooking != null && newBooking != null) {
      if (
        newBooking.externalBookingIdsDto &&
        newBooking.externalBookingIdsDto.externalBookingSource &&
        newBooking.externalBookingIdsDto.externalBookingSource ===
          'TRAVEL_AGENCY'
      ) {
        if (
          newBooking.travelAgencyData != null &&
          newBooking.travelAgencyData.finalClientFirstName != null &&
          newBooking.travelAgencyData.finalClientFirstName !== '' &&
          newBooking.travelAgencyData.finalClientCountry !== null &&
          newBooking.travelAgencyData.finalClientCountry !==
            '00000000-0000-0000-0000-000000000000'
        ) {
          const storedBooking = {
            ...newBooking,
            travelAgencyData: {
              finalClientFirstName:
                newBooking.travelAgencyData.finalClientFirstName ?? '',
              finalClientLastName:
                newBooking.travelAgencyData.finalClientLastName ?? '',
              finalClientCompany:
                newBooking.travelAgencyData.finalClientCompany ?? '',
              finalClientStreetAddress:
                newBooking.travelAgencyData.finalClientStreetAddress ?? '',
              finalClientZipCode:
                newBooking.travelAgencyData.finalClientZipCode ?? '',
              finalClientCity:
                newBooking.travelAgencyData.finalClientCity ?? '',
              finalClientCountry:
                newBooking.travelAgencyData.finalClientCountry ?? '',
              finalClientEmail:
                newBooking.travelAgencyData.finalClientEmail ?? '',
              finalClientPhone:
                newBooking.travelAgencyData.finalClientPhone ?? '',
            } as TravelAgencyData,
          };
          newBooking = {
            ...storedBooking,
            travelAgencyData: storedBooking.travelAgencyData,
          };
        } else {
          newBooking = { ...newBooking, travelAgencyData: null };
        }
      }
    }
    const container = {
      bookingContainerId: editedBookingLocal.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [newBooking],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBookingLocal !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            setBookingContainer(res.payload.result);
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: 'Virhe',
              }),
            );
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }

  const saveOwnerOwnBooking = () => {
    const ownerOwnBooking = {
      originalBookingId: editedBooking.id ?? '',
      ownerId: editedBookingLocal.bookingOrderItems[0].ownerAccountId,
      AccommodationId: editedBookingLocal.bookingOrderItems[0].accommodationId,
      ArrivalDateTime: editedBookingLocal.bookingOrderItems[0].arrivalDateTime,
      DepartureDateTime: editedBooking.bookingOrderItems[0].departureDateTime,
      OwnerBookingNote: {
        NoteText: '',
      } as OwnerOwnBookingNote,
      Adults: 0,
      Childs: 0,
      BookingType: editedBookingLocal.bookingType.toString(),
    } as OwnerOwnBooking;
    // TODO: Handle arrival and departure time
    ownerOwnBooking.AccommodationId =
      editedBookingLocal.bookingOrderItems[0].accommodationId;
    ownerOwnBooking.ArrivalDateTime =
      editedBookingLocal.bookingOrderItems[0].startDateTime;
    ownerOwnBooking.DepartureDateTime =
      editedBookingLocal.bookingOrderItems[0].endDateTime;
    const numberOfPeopleInBooking =
      editedBookingLocal.bookingOrderItems[0].amountOfAdults +
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    let notetext = '';
    let notetextCustomer = '';
    if (linenChecked) {
      notetext += `Sisältää liinavaatteet ${numberOfPeopleInBooking} kpl\n`;
    }
    if (cleaningChecked) {
      notetext += 'Sisältää loppusiivouksen\n';
    }
    if (
      editedOwnerBookingNotes !== null &&
      editedOwnerBookingNotes.length > 0
    ) {
      editedOwnerBookingNotes.map(note => {
        if (!notetext.includes(note.noteText)) {
          notetext += ` ${note.noteText}\n`;
        }
        return notetext;
      });
    }
    if (
      editedCustomerBookingNotes !== null &&
      editedCustomerBookingNotes.length > 0
    ) {
      editedCustomerBookingNotes.map(note => {
        notetextCustomer = note.noteText;
        return notetextCustomer;
      });
    }
    ownerOwnBooking.CustomerBookingNote = {
      NoteText: notetextCustomer,
    } as OwnerOwnBookingNote;

    ownerOwnBooking.OwnerBookingNote = {
      NoteText: notetext,
    } as OwnerOwnBookingNote;
    ownerOwnBooking.Adults = editedBooking.bookingOrderItems[0].amountOfAdults;
    ownerOwnBooking.Childs =
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    ownerOwnBooking.BookingType = editedBookingLocal.bookingType.toString();
    // callParentInitFetch();
    // handleModalClose();
    setshowLoader(true);
    dispatch(saveOwnerOwnBookingAsync(ownerOwnBooking))
      .then(res => {
        if (res.meta.requestStatus === 'fulfilled') {
          setEditedBooking(res.payload);
          setEditedBookingLocal(res.payload);
          dispatch(getBookingContainerDetailsAsync(res.payload.id));
          dispatch(
            addStatusToast({
              Message: `Omistajan oma varaus tallennettu!`,
            }),
          );
          dispatch(setBasketContainer(initialBookingContainer)).then(() => {
            history(`/bookings/${res.payload.id}`, {});
            handleCloseBookingOwner();
          });
        }
      })
      .finally(() => {
        setshowLoader(false);
      });
  };
  function getGlobalEndDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].endDateTime;
      }
    }
    if (globalEndDate) {
      return globalEndDate;
    }
    return '';
  }

  function getGlobalStartDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].startDateTime;
      }
    }
    if (globalStartDate) {
      return globalStartDate;
    }
    return '';
  }
  const checkAvailability = () => {
    const ownerOwnBooking = {
      originalBookingId: editedBookingLocal.id ?? '',
      ownerId: editedBookingLocal.bookingOrderItems[0].ownerAccountId,
      AccommodationId: editedBookingLocal.bookingOrderItems[0].accommodationId,
      ArrivalDateTime: editedBookingLocal.bookingOrderItems[0].arrivalDateTime,
      DepartureDateTime: editedBooking.bookingOrderItems[0].departureDateTime,
      OwnerBookingNote: {
        NoteText: '',
      } as OwnerOwnBookingNote,
      Adults: 0,
      Childs: 0,
      BookingType: '',
    } as OwnerOwnBooking;
    // TODO: Handle arrival and departure time
    ownerOwnBooking.AccommodationId =
      editedBookingLocal.bookingOrderItems[0].accommodationId;
    ownerOwnBooking.ArrivalDateTime =
      editedBookingLocal.bookingOrderItems[0].startDateTime;
    ownerOwnBooking.DepartureDateTime =
      editedBookingLocal.bookingOrderItems[0].endDateTime;
    const numberOfPeopleInBooking =
      editedBookingLocal.bookingOrderItems[0].amountOfAdults +
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    let notetext = '';
    let notetextCustomer = '';
    if (linenChecked) {
      notetext += `Sisältää liinavaatteet ${numberOfPeopleInBooking} kpl\n`;
    }
    if (cleaningChecked) {
      notetext += 'Sisältää loppusiivouksen\n';
    }
    if (
      editedOwnerBookingNotes !== null &&
      editedOwnerBookingNotes.length > 0
    ) {
      editedOwnerBookingNotes.map(note => {
        notetext = note.noteText;
        return notetext;
      });
    }
    if (
      editedCustomerBookingNotes !== null &&
      editedCustomerBookingNotes.length > 0
    ) {
      editedCustomerBookingNotes.map(note => {
        notetextCustomer = note.noteText;
        return notetextCustomer;
      });
    }
    ownerOwnBooking.OwnerBookingNote = {
      NoteText: notetext,
    } as OwnerOwnBookingNote;

    ownerOwnBooking.CustomerBookingNote = {
      NoteText: notetextCustomer,
    } as OwnerOwnBookingNote;
    ownerOwnBooking.Adults = editedBooking.bookingOrderItems[0].amountOfAdults;
    ownerOwnBooking.Childs =
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    ownerOwnBooking.BookingType = editedBooking.bookingType.toString();
    // callParentInitFetch();
    // handleModalClose();
    setshowLoader(true);
    dispatch(saveOwnerOwnBookingAsync(ownerOwnBooking))
      .then(res => {
        if (res.meta.requestStatus === 'fulfilled') {
          setEditedBooking(res.payload);
          setIsAvailCheckActive(false);
          setEditedBookingLocal(res.payload);
          dispatch(getBookingContainerDetailsAsync(res.payload.id));
          dispatch(
            addStatusToast({
              Message: `Omistajan oma varaus tallennettu!`,
            }),
          );
          dispatch(setBasketContainer(initialBookingContainer)).then(() => {
            history(`/bookings/${res.payload.id}`, {});
            // handleCloseBookingOwner();
          });
        }
      })
      .finally(() => {
        setshowLoader(false);
      });
  };
  function localSetEditedBooking(booking) {
    setEditedBookingLocal(booking);
  }
  function makeOwnerBooking(newType) {
    if (editedBookingLocal !== null) {
      const newbookingOrderItems = [] as BookingDetailsOrderItem[];
      editedBookingLocal.bookingOrderItems.map(item => {
        if (item.orderItemType === 0) {
          item = {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              netPrice: 0,
              grossPrice: 0,
              grossPriceVat: 0,
              discountP: 0,
              travelAgencyComissionP: 0,
            },
            purchasePricesResponse: {
              ...item.purchasePricesResponse,
              sitePurchasePrice: 0,
              sitePurchasePriceVat: 0,
              ownerPurchasePrice: 0,
              ownerPurchasePriceVat: 0,
            },
          };
          return newbookingOrderItems.push(item);
        }
        return null;
      });

      // Create a new copy of editedBooking and update bookingOrderItems
      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newbookingOrderItems,
        bookingType: newType ?? 5,
      };
      localSetEditedBooking(newEditedBooking);
      setMakingOwnerBooking(true);
    }
  }
  function confirmBooking() {
    if (
      editedBookingLocal &&
      editedBookingLocal.bookingType === 0 &&
      (editedBookingLocal.preliminaryBookingDueDate === null ||
        editedBookingLocal.preliminaryBookingDueDate === undefined)
    ) {
      const editedBookingLocalStore = {
        ...editedBookingLocal,
        errors: ['Alustavan varauksen voimassaolo puuttuu !'],
      };
      setEditedBookingLocal(editedBookingLocalStore);
      setShowDueDateConfirmation(true);
      return;
    }
    setshowLoader(true);
    if (editedBookingLocal === null) {
      return;
    }
    let container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;

    if (editedBooking.travelAgencyData !== null) {
      const storedBooking = {
        ...editedBookingLocal,
        travelAgencyData: {
          finalClientFirstName:
            editedBookingLocal.travelAgencyData.finalClientFirstName ?? '',
          finalClientLastName:
            editedBookingLocal.travelAgencyData.finalClientLastName ?? '',
          finalClientCompany:
            editedBookingLocal.travelAgencyData.finalClientCompany ?? '',
          finalClientStreetAddress:
            editedBookingLocal.travelAgencyData.finalClientStreetAddress ?? '',
          finalClientZipCode:
            editedBookingLocal.travelAgencyData.finalClientZipCode ?? '',
          finalClientCity:
            editedBookingLocal.travelAgencyData.finalClientCity ?? '',
          finalClientCountry:
            editedBookingLocal.travelAgencyData.finalClientCountry ?? '',
          finalClientEmail:
            editedBookingLocal.travelAgencyData.finalClientEmail ?? '',
          finalClientPhone:
            editedBookingLocal.travelAgencyData.finalClientPhone ?? '',
        } as TravelAgencyData,
      };
      container = { ...container, bookings: [storedBooking] };
    }
    if (editedBookingLocal !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container)).then(res3 => {
        if (res3.payload.isSuccess === true) {
          const findItem = res3.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          setBookingContainer(res3.payload.result);
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res3.payload.result));
            setshowLoader(true);
            let storeBooking = { ...findItem[0] };
            if (editedBookingLocal.byPassAdvanceSum === true) {
              storeBooking = {
                ...storeBooking,
                byPassAdvanceSum: editedBookingLocal.byPassAdvanceSum,
              };
            }
            if (editedBookingLocal.byPassSellPriceCheck === true) {
              storeBooking = {
                ...storeBooking,
                byPassSellPriceCheck: editedBookingLocal.byPassSellPriceCheck,
              };
            }
            console.log(
              'Override vahvista:',
              editedBookingLocal.overrideAdvanceBillPrice,
            );
            // if (
            //   editedBookingLocal.overrideAdvanceBillPrice !== null &&
            //   editedBookingLocal.overrideAdvanceBillPrice > 0
            // ) {
            //   storeBooking = {
            //     ...storeBooking,
            //     byPassAdvanceSum: true,
            //   };
            // }
            dispatch(setWebShopCustomerState(null));
            dispatch(confirmBookingAsync(storeBooking))
              .then(res => {
                if (res.payload.isSuccess === true) {
                  setshowLoader(true);
                  const findItem2 = res.payload.result.bookingResponses.filter(
                    i => i.id === editedBooking.id,
                  );
                  if (findItem2 != null && findItem2.length > 0) {
                    setEditedBookingLocal(findItem2[0]);
                    setEditedBooking(findItem2[0]);
                    dispatch(getBookingContainerDetailsAsync(findItem2[0].id));
                    dispatch(setBasketContainer(initialBookingContainer)).then(
                      () => {
                        setShowNewBookingModal(false);
                        const navigationPath = `/bookings/${findItem2[0].id}`;
                        history(navigationPath, {
                          state: {
                            id: res.payload.result.id,
                            from: window.location.pathname,
                          },
                        });
                      },
                    );
                  }
                } else {
                  if (res.payload.message != null) {
                    dispatch(
                      addStatusToast({
                        Message: res.payload.message,
                        IsFailed: true,
                        Title: 'Virhe',
                      }),
                    );
                  }
                  if (
                    res.payload.result != null &&
                    res.payload.result.errors != null &&
                    res.payload.result.errors.length > 0
                  ) {
                    res.payload.result.errors.map(error => {
                      return dispatch(
                        addStatusToast({
                          Message: error,
                          IsFailed: true,
                          Title: 'Virhe',
                          DelayMs: 10000,
                          IsAutohide: false,
                        }),
                      );
                    });
                  }
                }
              })
              .catch(err => {
                dispatch(
                  addStatusToast({
                    Message: 'Virhe varauksen vahvistamisessa',
                    IsFailed: true,
                    Title: 'Virhe',
                  }),
                );
                setshowLoader(false);
              })
              .finally(() => {
                // console.debug('closeloader 2');
                // setshowLoader(false);
              });
          }
        } else {
          const findItem = res3.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          console.debug(
            'Error updating booking container',
            res3.payload.result.errors,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res3.payload.result));
          }
          dispatch(
            addStatusToast({
              Message:
                t(
                  `travelAgencyBookingModal:validation:errors.${
                    res3.payload.result.errors[0]
                  }`,
                ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
              IsFailed: true,
              Title: 'Virhe',
            }),
          );
          setShowNewBookingModal(false);
        }
      });
    }
  }
  useEffect(() => {
    initFetch();
  }, [initFetch]);

  useEffect(() => {
    if (bookingTypeParam) {
      // Update local state when editedBooking changes
      if (editedBookingLocal) {
        // If it's a completely different booking, replace the whole object
        const newBooking = {
          ...editedBookingLocal,
          bookingType: bookingTypeParam,
        };
        setEditedBookingLocal(newBooking);
      }
    }
  }, [bookingTypeParam]);

  useEffect(() => {
    if (
      selectableAddOns !== null &&
      selectableAddOns.length > 0 &&
      editedBooking != null
    ) {
      const accommodationItem = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (accommodationItem) {
        const perGuestAddOns = selectableAddOns
          .filter(a => a.amountPerGuest === true)
          .map(addOn => ({
            ...addOn,
            amountOfAdults: accommodationItem.amountOfAdults,
            amountOfUnits:
              accommodationItem.amountOfAdults +
              accommodationItem.amountOfChildren,
          }));

        const perUnitAddOns = selectableAddOns
          .filter(a => a.amountPerGuest === false)
          .map(addOn => ({
            ...addOn,
            amountOfAdults: accommodationItem.amountOfAdults,
            amountOfUnits:
              accommodationItem.amountOfAdults +
              accommodationItem.amountOfChildren,
          }));

        const updatedSelectableAddOns = [...perGuestAddOns, ...perUnitAddOns];
        seteditedSelectableAddOns(updatedSelectableAddOns);
      }
    }
  }, [selectableAddOns, editedBooking]);

  useEffect(() => {
    if (editedBookingLocal) {
      if (editedBookingLocal.customerBookingNotes) {
        setEditedCustomerBookingNotes(editedBookingLocal.customerBookingNotes);
      }
      if (editedBookingLocal.ownerBookingNotes) {
        setEditedOwnerBookingNotes(editedBookingLocal.ownerBookingNotes);
      }
      if (editedBookingLocal.officerBookingNotes) {
        setEditedOfficerBookingNotes(editedBookingLocal.officerBookingNotes);
      }
      if (
        bookingTypeParam &&
        editedBookingLocal.bookingType !== bookingTypeParam
      ) {
        const newBooking = {
          ...editedBookingLocal,
          bookingType: bookingTypeParam,
        };

        setEditedBookingLocal(newBooking);
      }
      if (
        editedBookingLocal.bookingOrderItems !== null &&
        editedBookingLocal.bookingOrderItems.length > 0
      ) {
        setGlobalStartDate(
          editedBookingLocal.bookingOrderItems.find(
            i => i.orderItemType !== null,
          )?.startDateTime,
        );
        setGlobalEndDate(
          editedBookingLocal.bookingOrderItems.find(
            i => i.orderItemType !== null,
          )?.endDateTime,
        );
      }
    }
  }, [editedBookingLocal]);
  useEffect(() => {}, [showLoader]);
  useEffect(() => {
    if (editedBooking) {
      const item = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (item) {
        const filter = {
          accommodationId: item.accommodationId,
          units: item.units,
          adults: item.amountOfAdults,
          childs: item.amountOfChildren,
          includeNonVisible: true,
        } as SelectableAddOnFilter;
        dispatch(getSelectableAddOnsAsync(filter)).then(res => {
          if (
            res.meta.requestStatus === 'fulfilled' &&
            res.payload &&
            res.payload.length > 0
          ) {
            seteditedSelectableAddOns(res.payload);
          } else {
            seteditedSelectableAddOns([]);
          }
        });
      }
      if (
        editedBooking !== null &&
        editedBooking !== undefined &&
        editedBooking.payerId !== null &&
        editedBooking.payerId !== 'undefined' &&
        editedBooking.payerId !== ''
      ) {
        dispatch(getAcountDetailsFromDbAsync(editedBooking.payerId)).then(
          res => {
            setSelectedPayer(res.payload);
          },
        );
      } else {
        setSelectedPayer(null);
      }
      setEditedBookingLocal(editedBooking);
    }
  }, [editedBooking, dispatch]);

  useEffect(() => {
    if (makingOwnerBooking) {
      if (
        editedBookingLocal?.bookingType === 5 ||
        editedBookingLocal?.bookingType === 13
      ) {
        makeOwnerBooking(editedBookingLocal?.bookingType);
      }
    }
  }, [makingOwnerBooking]);
  useEffect(() => {
    if (
      editedBookingLocal?.bookingType === 5 ||
      editedBookingLocal?.bookingType === 13
    ) {
      setMakingOwnerBooking(true);
    }
    if (editedBookingLocal?.bookingType === 5) {
      setOwnerOwnBookingType('OwnerOwn');
    }
    if (editedBookingLocal?.bookingType === 13) {
      setOwnerOwnBookingType('TemporaryDisabled');
    }
  }, [editedBookingLocal]);

  useEffect(() => {
    // This runs when the component mounts
    return () => {
      dispatch(setWebShopCustomerState(null));
    };
  }, []);
  function selectPayer() {
    if (editedBookingLocal === null) {
      return;
    }

    let container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;

    if (editedBooking.travelAgencyData !== null) {
      const storedBooking = {
        ...editedBookingLocal,
        travelAgencyData: {
          finalClientFirstName:
            editedBookingLocal.travelAgencyData.finalClientFirstName ?? '',
          finalClientLastName:
            editedBookingLocal.travelAgencyData.finalClientLastName ?? '',
          finalClientCompany:
            editedBookingLocal.travelAgencyData.finalClientCompany ?? '',
          finalClientStreetAddress:
            editedBookingLocal.travelAgencyData.finalClientStreetAddress ?? '',
          finalClientZipCode:
            editedBookingLocal.travelAgencyData.finalClientZipCode ?? '',
          finalClientCity:
            editedBookingLocal.travelAgencyData.finalClientCity ?? '',
          finalClientCountry:
            editedBookingLocal.travelAgencyData.finalClientCountry ?? '',
          finalClientEmail:
            editedBookingLocal.travelAgencyData.finalClientEmail ?? '',
          finalClientPhone:
            editedBookingLocal.travelAgencyData.finalClientPhone ?? '',
        } as TravelAgencyData,
      };
      container = { ...container, bookings: [storedBooking] };
    }
    if (editedBooking !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            if (
              webshopCustomer !== null &&
              webshopCustomer !== undefined &&
              webshopCustomer.lastName != null &&
              (editedBooking.payerId === null ||
                editedBooking.payerId === undefined)
            ) {
              const init = {
                payer: 'pick',
                bookingId: editedBookingLocal.id,
                bookingType: editedBookingLocal.bookingType,
                bookingLocale: editedBookingLocal.invoicingLanguageLocale,
                webshopCustomer,
              };
              // Keep session in sync for Customers page
              sessionStorage.setItem('bookingId', editedBookingLocal.id ?? '');
              sessionStorage.setItem(
                'bookingType',
                String(editedBookingLocal.bookingType ?? ''),
              );
              sessionStorage.setItem(
                'bookingLocale',
                editedBookingLocal.invoicingLanguageLocale ?? '',
              );
              history(`/customers/search`, { state: init });
            } else if (
              webshopCustomer !== null &&
              webshopCustomer !== undefined &&
              webshopCustomer.lastName != null &&
              editedBooking.payerId !== null &&
              editedBooking.payerId !== undefined &&
              editedBooking.payerId !== 'undefined'
            ) {
              const init = {
                payer: 'pick',
                bookingId: editedBookingLocal.id,
                bookingType: editedBookingLocal.bookingType,
                bookingLocale: editedBookingLocal.invoicingLanguageLocale,
                webshopCustomer,
              };
              // Keep session in sync for Customers page
              sessionStorage.setItem('bookingId', editedBookingLocal.id ?? '');
              sessionStorage.setItem(
                'bookingType',
                String(editedBookingLocal.bookingType ?? ''),
              );
              sessionStorage.setItem(
                'bookingLocale',
                editedBookingLocal.invoicingLanguageLocale ?? '',
              );
              history(`/customers/search`, {
                state: init,
              });
            } else {
              const webshopCustomerCommand = {
                firstName: editedBooking.payerFirstName,
                lastName: editedBooking.payerLastName,
              } as WebShopCustomerItem;
              const init = {
                payer: 'pick',
                bookingId: editedBookingLocal.id,
                bookingType: editedBookingLocal.bookingType,
                bookingLocale: editedBookingLocal.invoicingLanguageLocale,
                webshopCustomer: webshopCustomerCommand,
              };
              // Keep session in sync for Customers page
              sessionStorage.setItem('bookingId', editedBookingLocal.id ?? '');
              sessionStorage.setItem(
                'bookingType',
                String(editedBookingLocal.bookingType ?? ''),
              );
              sessionStorage.setItem(
                'bookingLocale',
                editedBookingLocal.invoicingLanguageLocale ?? '',
              );
              history(`/customers/search`, {
                state: init,
              });
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            console.debug(
              'Error updating booking container',
              res.payload.result.errors,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: 'Virhe',
              }),
            );
            // Virheitä mökissä
            setShowNewBookingModal(false);
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }
  const handleAddCustomerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedCustomerBookingNotes, newbookingNote];
    setEditedCustomerBookingNotes(newBookingNoteItems);
  };
  const handleAddOwnerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedOwnerBookingNotes, newbookingNote];
    setEditedOwnerBookingNotes(newBookingNoteItems);
  };
  const handleAddOfficerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedOfficerBookingNotes, newbookingNote];
    setEditedOfficerBookingNotes(newBookingNoteItems);
  };
  const handleAddToContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedSelectableAddOns[index];
    // Update the state
    const addAddOnData = {
      bookingId: editedBookingLocal.id,
      accommodationAddOnId: addedItem.id,
      adults: addedItem.amountOfAdults,
      childs: addedItem.amountOfChildren,
      units:
        addedItem.amountPerGuest === true &&
        addedItem.units !==
          addedItem.amountOfAdults + addedItem.amountOfChildren
          ? addedItem.amountOfAdults + addedItem.amountOfChildren
          : addedItem.units,
      grossPrice: addedItem.pricesResponse.grossPrice,
      sitePurchasePrice: addedItem.purchasePricesResponse.sitePurchasePrice,
      arrivalDateTime: getGlobalStartDate(),
      departureDateTime: getGlobalEndDate(),
      bookingContainerId: editedBooking.bookingContainerId,
    } as AddAddOnToBookingContainerItem;
    dispatch(addAddOnToBookingContainerAsync(addAddOnData)).then(res => {
      if (res.payload.isSuccess === true) {
        const findItem = res.payload.result.bookingResponses.filter(
          i => i.id === editedBooking.id,
        );
        if (findItem != null && findItem.length > 0) {
          updateBookingContainer();
          const newBookingOrderItems = [
            ...editedBookingLocal.bookingOrderItems,
            addedItem,
          ];

          // Create a new copy of editedBooking and update bookingOrderItems
          const newEditedBooking = {
            ...editedBookingLocal,
            bookingType: editedBookingLocal.bookingType,
            bookingOrderItems: newBookingOrderItems,
          };
          localSetEditedBooking(newEditedBooking);
          const newEditedBookingResponse = {
            ...findItem[0],
            bookingType: editedBookingLocal.bookingType,
          };
          setEditedBookingLocal(newEditedBookingResponse);
          setEditedBooking(newEditedBookingResponse);
          dispatch(setBookingContainer(res.payload.result));
        }
      }
    });
  };

  function handleUpdateToPleriminaryBooking() {
    const container = {
      bookingId: editedBooking.id,
    } as UpdateBookingToPreliminary;
    if (editedBookingLocal !== null) {
      dispatch(UpdateBookingToPreliminaryAsync(container)).then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
        }
      });
    }
  }

  const handlAllowAdvanceByPassChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      byPassAdvanceSum: value,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlAllowPriceByPassChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      byPassSellPriceCheck: value,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };
  const handlGrosPriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = event;
    let { value } = target;

    // Allow empty string while editing
    if (value === '') {
      const index = Number(target.name);
      const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
      newBookingOrderItems[index] = {
        ...newBookingOrderItems[index],
        // store as null so UI shows ''
        pricesResponse: {
          ...newBookingOrderItems[index].pricesResponse,
          grossPrice: null as unknown as number, // keep type, render '' below
        },
      };
      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newBookingOrderItems,
      };
      localSetEditedBooking(newEditedBooking);
      return;
    }

    // Normalize: remove leading zeros but keep single '0'
    value = value.replace(/^(-?)0+(?=\d)/, '$1');

    // Disallow negatives by snapping to empty (or you can snap to 0)
    if (Number(value) < 0) {
      value = '';
    }

    const index = Number(target.name);
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        grossPrice: value === '' ? (null as unknown as number) : Number(value),
      },
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    localSetEditedBooking(newEditedBooking);
  };

  const handleSitePurchsePriceChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { target } = event;
    let { value } = target;

    // Allow empty string while editing
    if (value === '') {
      const index = Number(target.name);
      const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
      newBookingOrderItems[index] = {
        ...newBookingOrderItems[index],
        // store as null so UI shows ''
        purchasePricesResponse: {
          ...newBookingOrderItems[index].purchasePricesResponse,
          sitePurchasePrice: null as unknown as number, // keep type, render '' below
        },
      };
      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newBookingOrderItems,
      };
      localSetEditedBooking(newEditedBooking);
      return;
    }

    // Normalize: remove leading zeros but keep single '0'
    value = value.replace(/^(-?)0+(?=\d)/, '$1');

    // Disallow negatives by snapping to empty (or you can snap to 0)
    if (Number(value) < 0) {
      value = '';
    }

    const index = Number(target.name);
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      purchasePricesResponse: {
        ...newBookingOrderItems[index].purchasePricesResponse,
        sitePurchasePrice:
          value === '' ? (null as unknown as number) : Number(value),
      },
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    localSetEditedBooking(newEditedBooking);
  };

  const handleOwnerPurchsePriceChange = event => {
    const { target } = event;
    let { value } = target;
    if (value < 0) {
      value = '';
    }
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      purchasePricesResponse: {
        ...newBookingOrderItems[index].purchasePricesResponse,
        ownerPurchasePrice: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlTravelPChange = event => {
    const { target } = event;
    let { value } = target;
    if (value <= 0) {
      value = '';
    }
    // const index = Number(target.name);
    // // Create a new copy of bookingOrderItems array
    // const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
    //
    // // Update the grossPrice of the item at the given index
    // newBookingOrderItems[index] = {
    //   ...newBookingOrderItems[index],
    //   pricesResponse: {
    //     ...newBookingOrderItems[index].pricesResponse,
    //     travelAgencyComissionP: Number(value),
    //   },
    // };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      overrideTravelCommission: Number(value),
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlAdvanceBillPriceChange = event => {
    const { target } = event;
    const { value } = target;
    // Create a new copy of editedBooking and update advanceBillPrice
    if (Number.isInteger(value) && Number(value) < 0) {
      const newEditedBooking = {
        ...editedBookingLocal,
        overrideAdvanceBillPrice: 0,
      };

      // Update the state
      localSetEditedBooking(newEditedBooking);
    } else {
      const newEditedBooking = {
        ...editedBookingLocal,
        overrideAdvanceBillPrice: Number(value),
      };
      console.log('Ennakkomaksun uusi määrä:', value);
      console.log(
        'Ennakkomaksun vanha määrä:',
        editedBookingLocal.overrideAdvanceBillPrice,
      );
      console.log('laskulla:', editedBookingLocal.advanceBillPrice);
      // Update the state
      localSetEditedBooking(newEditedBooking);
    }
  };
  const handlDiscountChange = event => {
    const { target } = event;
    let { value } = target;
    if (value < 0) {
      value = '';
    }
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        discountP: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  function enumToArray(enumObj: unknown) {
    const keys = Object.keys(enumObj);
    return keys
      .filter(key => Number.isInteger(Number.parseInt(enumObj[key], 10)))
      .map(key => ({ name: key, value: Number.parseInt(enumObj[key], 10) }));
  }
  function getBookingTypeTranslation(
    bookingType: BookingType,
    locale: 'en' | 'fi',
  ): string {
    return bookingTypeTranslations[locale][bookingType] || 'Tuntematon';
  }
  const bookingTypeItems = enumToArray(BookingType)
    .filter(
      b => b.value !== 15 && b.value !== 14 && b.value !== 11 && b.value !== 12,
    )
    .map(item => {
      return {
        value: item.value,
        label: getBookingTypeTranslation(item.value, 'fi'),
      };
    });
  const getAllowedBookingTypes = () => {
    if (editedBookingLocal === null || editedBookingLocal === undefined) {
      return bookingTypeItems;
    }
    if (editedBooking.payerId == null || editedBooking.payerId == null) {
      return bookingTypeItems.filter(
        bt => bt.value === 0 || bt.value === 13 || bt.value === 5,
      );
    }
    const realOwnerExists = editedBookingLocal.bookingOrderItems.find(
      oi => oi.realOwnerAccountId !== null && oi.realOwnerAccountId.length > 1,
    );
    if (editedBookingLocal.bookingType === 0 && !realOwnerExists) {
      return bookingTypeItems.filter(
        bt =>
          bt.value === 1 ||
          bt.value === 0 ||
          bt.value === 15 ||
          bt.value === 5 ||
          bt.value === 13 ||
          bt.value === 2 ||
          bt.value === 6,
      );
    }
    if (editedBookingLocal.bookingType === 0 && realOwnerExists) {
      return bookingTypeItems.filter(
        bt =>
          bt.value === 1 ||
          bt.value === 0 ||
          bt.value === 15 ||
          bt.value === 2 ||
          bt.value === 6,
      );
    }
    if (editedBookingLocal.bookingType === 1) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 0);
    }
    if (editedBookingLocal.bookingType === 2) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 2);
    }
    if (editedBookingLocal.bookingType === 3) {
      return bookingTypeItems.filter(bt => bt.value === 4 || bt.value === 3);
    }
    if (editedBooking.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 10) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBookingLocal.bookingType === 4) {
      return bookingTypeItems.filter(bt => bt.value === 4);
    }
    if (editedBookingLocal.bookingType === 5) {
      return bookingTypeItems.filter(bt => bt.value === 5 || bt.value === 13);
    }
    if (editedBookingLocal.bookingType === 6) {
      return bookingTypeItems.filter(bt => bt.value === 6 || bt.value === 0);
    }
    if (editedBookingLocal.bookingType === 7) {
      return bookingTypeItems.filter(bt => bt.value === 8 || bt.value === 7);
    }
    if (editedBookingLocal.bookingType === 8) {
      return bookingTypeItems.filter(bt => bt.value === 8);
    }
    if (editedBookingLocal.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBookingLocal.bookingType === 13) {
      return bookingTypeItems.filter(bt => bt.value === 13 || bt.value === 5);
    }
    if (editedBookingLocal.bookingType === 14) {
      return bookingTypeItems.filter(bt => bt.value === 14);
    }
    if (editedBookingLocal.bookingType === 15) {
      return bookingTypeItems.filter(bt => bt.value === 0 || bt.value === 15);
    }
    return bookingTypeItems;
  };
  const getAllowedBookingTypesPreliminary = () => {
    if (editedBookingLocal === null || editedBookingLocal === undefined) {
      return bookingTypeItems;
    }
    if (editedBooking.payerId == null || editedBooking.payerId == null) {
      return bookingTypeItems.filter(
        bt => bt.value === 0 || bt.value === 13 || bt.value === 5,
      );
    }
    if (
      editedBookingLocal.bookingType === 0 &&
      editedBookingLocal.ownSiteAccommodation
    ) {
      return bookingTypeItems;
    }
    if (
      editedBookingLocal.bookingType === 0 &&
      !editedBookingLocal.ownSiteAccommodation
    ) {
      return bookingTypeItems.filter(bt => bt.value !== 5 && bt.value !== 13);
    }
    if (
      editedBookingLocal.bookingType === 5 ||
      editedBookingLocal.bookingType === 13
    ) {
      return bookingTypeItems.filter(
        bt => bt.value === 0 || bt.value === 5 || bt.value === 13,
      );
    }
    return bookingTypeItems;
  };
  const billingLocales = enumToArray(BillingLocales).map(item => {
    return { value: item.value, label: item.name };
  });
  const handlUnitsChange = event => {
    const { target } = event;
    let { value } = target;
    if (value < 0) {
      value = '';
    }
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
      addOnId: newBookingOrderItems[index].addOnId,
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
    updateBookingContainerWithData(
      newEditedBooking,
      newEditedBooking.bookingType,
    );
  };
  const formatDateTime = date => {
    if (!date) return null;

    // Set the desired time (e.g., 16:00:00)
    date.setHours(16, 0, 0, 0); // 16:00:00, with milliseconds set to 0

    // Convert to ISO string and then remove the 'Z' (which indicates UTC time)
    // Take only YYYY-MM-DDTHH:MM:SS
    return date.toISOString().slice(0, 19);
  };
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const handleAdvanceInvoiceDueDateDateChange = useCallback(
    (date: Date | null, index: number) => {
      if (!date || !editedBookingLocal) return;
      // Format the date in the local timezone
      const formattedDate = formatInTimeZone(
        date,
        timeZone,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      );

      // const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

      const storeEeditedBookingLocal = {
        ...editedBookingLocal,
        advanceInvoiceDueDate: formattedDate,
      };

      localSetEditedBooking(storeEeditedBookingLocal);
      updateBookingContainerWithData(
        storeEeditedBookingLocal,
        storeEeditedBookingLocal.bookingType,
      );
    },
    [editedBookingLocal, localSetEditedBooking, updateBookingContainerWithData],
  );
  const handleFinalInvoiceDueDateDateChange = useCallback(
    (date: Date | null, index: number) => {
      if (!date || !editedBookingLocal) return;
      // Format the date in the local timezone
      const formattedDate = formatInTimeZone(
        date,
        timeZone,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      );

      // const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

      const storeEeditedBookingLocal = {
        ...editedBookingLocal,
        finalInvoiceDueDate: formattedDate,
      };

      localSetEditedBooking(storeEeditedBookingLocal);
      updateBookingContainerWithData(
        storeEeditedBookingLocal,
        storeEeditedBookingLocal.bookingType,
      );
    },
    [editedBookingLocal, localSetEditedBooking, updateBookingContainerWithData],
  );
  const handleDueDateDateChange = useCallback(
    (date: Date | null, index: number) => {
      if (!date || !editedBookingLocal) return;
      // Format the date in the local timezone
      const formattedDate = formatInTimeZone(
        date,
        timeZone,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      );

      // const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

      const storeEeditedBookingLocal = {
        ...editedBookingLocal,
        preliminaryBookingDueDate: formattedDate,
      };

      localSetEditedBooking(storeEeditedBookingLocal);
      updateBookingContainerWithData(
        storeEeditedBookingLocal,
        storeEeditedBookingLocal.bookingType,
      );
    },
    [editedBookingLocal, localSetEditedBooking, updateBookingContainerWithData],
  );

  const handleStartDateChange = useCallback(
    (date: Date | null, index: number) => {
      if (!date || !editedBookingLocal) return;

      // Format the date in the local timezone
      const formattedDate = formatInTimeZone(
        date,
        timeZone,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      );

      const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

      newBookingOrderItems[index] = {
        ...newBookingOrderItems[index],
        startDateTime: formattedDate,
      };

      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newBookingOrderItems,
      };

      localSetEditedBooking(newEditedBooking);
      setIsAvailCheckActive(true);
      // updateBookingContainerWithData(
      //   newEditedBooking,
      //   newEditedBooking.bookingType,
      // );
    },
    [editedBookingLocal, localSetEditedBooking, updateBookingContainerWithData],
  );

  const handleEndDateChange = useCallback(
    (date: Date | null, index: number) => {
      if (!date || !editedBookingLocal) return;

      // Format the date in the local timezone
      const formattedDate = formatInTimeZone(
        date,
        timeZone,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      );

      const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

      newBookingOrderItems[index] = {
        ...newBookingOrderItems[index],
        endDateTime: formattedDate,
      };

      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newBookingOrderItems,
      };

      localSetEditedBooking(newEditedBooking);
      setIsAvailCheckActive(true);
      // updateBookingContainerWithData(
      //   newEditedBooking,
      //   newEditedBooking.bookingType,
      // );
    },
    [editedBookingLocal, localSetEditedBooking, updateBookingContainerWithData],
  );

  const handlOfficerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedOfficerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedOfficerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      officerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };
  const handlOwnerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedOwnerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedOwnerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      ownerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };

  const handlCustomerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedCustomerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedCustomerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      customerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };

  const handlUnitsChangeSelectable = event => {
    const { target } = event;
    let { value } = target;
    if (value < 1) {
      value = 1;
    }
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlAdultsChangeRow = event => {
    const { target } = event;
    const { value } = target;
    let newAmountOfAdults = Number(value);
    if (newAmountOfAdults < 1) {
      newAmountOfAdults = 1;
    }

    // Update the amountOfAdults for all bookingOrderItems
    const newBookingOrderItems = editedBookingLocal.bookingOrderItems.map(
      item => ({
        ...item,
        amountOfAdults: newAmountOfAdults,
      }),
    );

    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map(item => ({
        ...item,
        amountOfAdults: newAmountOfAdults,
      })),
    );
    updateBookingContainerWithData(
      newEditedBooking,
      newEditedBooking.bookingType,
    );
  };
  const handlChildChangeRow = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    let newAmountOfChildren = Number(value);
    if (newAmountOfChildren < 0) {
      newAmountOfChildren = 0;
    }
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = editedBookingLocal.bookingOrderItems.map(
      item => ({
        ...item,
        amountOfChildren: newAmountOfChildren,
      }),
    );

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfChildren: newAmountOfChildren,
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, indexx) => {
        return {
          ...item,
          amountOfChildren: Number(event.target.value),
        };
      }),
    );
    updateBookingContainerWithData(
      newEditedBooking,
      newEditedBooking.bookingType,
    );
  };

  const handlAdultsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);

    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = editedSelectableAddOns.map((item, idx) => {
      if (
        idx === index &&
        item.amountPerGuest === true &&
        item.amountSingeCharge === false
      ) {
        return {
          ...item,
          amountOfAdults: Number(value),
        };
      }
      return item;
    });

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const hanldleChildsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);

    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = editedSelectableAddOns.map((item, idx) => {
      if (
        idx === index &&
        item.amountPerGuest === true &&
        item.amountSingeCharge === false
      ) {
        return {
          ...item,
          amountOfChildren: Number(value),
        };
      }
      return item;
    });

    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlGrossPriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              grossPrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlPurchasePriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            purchasePricesResponse: {
              ...item.purchasePricesResponse,
              sitePurchasePrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlDiscountChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              discountP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlTravelCommissionPChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              travelAgencyComissionP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };
  const setRef = (el, index) => {
    textAreaRefs.current[index] = el;
  };
  const setOwnerRef = (el, index) => {
    ownertextAreaRefs.current[index] = el;
  };

  const setOfficerRef = (el, index) => {
    officertextAreaRefs.current[index] = el;
  };
  const generateItemKey = function (Index: number, Text: string) {
    return `${Index.toString()}-${encodeURI(Text.substring(0, 12))}`;
  };

  const handleSelectChangeBookingType = (selectedOption, name) => {
    if (selectedOption === null) {
      return;
    }
    if (selectedOption.value === 5 || selectedOption.value === 13) {
      const tempBookingTypeData2 = {
        ...editedBookingLocal,
        bookingType: selectedOption.value,
      };
      setEditedBookingLocal(tempBookingTypeData2);
      setMakingOwnerBooking(true);
      makeOwnerBooking(selectedOption.value);
    } else if (selectedOption.value !== 5 && selectedOption.value !== 13) {
      if (
        editedBookingLocal.bookingType === 5 ||
        editedBookingLocal.bookingType === 13
      ) {
        setMakingOwnerBooking(false);
        const tempBookingTypeData2 = {
          ...editedBooking,
          bookingType: selectedOption.value,
        };
        setEditedBookingLocal(tempBookingTypeData2);
        updateBookingContainerWithData(
          tempBookingTypeData2,
          selectedOption.value,
        );
      } else {
        // updateBookingContainer();
        setMakingOwnerBooking(false);
        const tempBookingTypeData2 = {
          ...editedBookingLocal,
          bookingType: selectedOption.value,
        };
        setEditedBookingLocal(tempBookingTypeData2);
        updateBookingContainerWithData(
          tempBookingTypeData2,
          selectedOption.value,
        );
      }
    }
  };
  const selectableAddOnItems = editedSelectableAddOns.map((item, index) => (
    <tr key={item.id}>
      <td>
        {item.addOnNumber !== null && item.addOnNumber > 0
          ? item.addOnNumber
          : ''}{' '}
        {item.accommodationNumber !== undefined && item.accommodationNumber > 0
          ? `${item.accommodationNumber} : `
          : ''}
        {item.itemName !== undefined ? item.itemName : ''}
        {item.includedInPrice && (
          <div className="text-danger">Sisältyy hintaan</div>
        )}
      </td>

      <td>
        {getGlobalStartDate() !== ''
          ? new Date(Date.parse(getGlobalStartDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}{' '}
        -{' '}
        {getGlobalEndDate() !== ''
          ? new Date(Date.parse(getGlobalEndDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerQuantity !== true}
          name={index.toString()}
          value={item.units ?? ''}
          onChange={handlUnitsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfAdults ?? ''}
          onChange={handlAdultsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfChildren ?? ''}
          onChange={hanldleChildsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.grossPrice ?? ''}
          onChange={handlGrossPriceChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.purchasePricesResponse.sitePurchasePrice ?? ''}
          onChange={handlPurchasePriceChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.discountP ?? ''}
          onChange={handlDiscountChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.travelAgencyComissionP ?? ''}
          onChange={handlTravelCommissionPChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Button
          size="sm"
          disabled={
            editedBookingLocal &&
            (editedBookingLocal.advanceBilled === null ||
              editedBookingLocal.advanceBilled === undefined ||
              editedBookingLocal.advanceBilled === false) &&
            editedBookingLocal.paymentAmount !== null &&
            editedBookingLocal.paymentAmount !== undefined &&
            editedBookingLocal.paymentAmount > 0
          }
          variant="outline-blue"
          name={index.toString()}
          onClick={handleAddToContainer}
        >
          Lisää varaukseen
        </Button>
      </td>
    </tr>
  ));
  const setLocalEndDate = async (date: Date) => {
    // setSelectedEndDate(date);
  };
  const handleRemoveFromContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedBookingLocal.bookingOrderItems[index];
    setshowLoader(true);
    // Update the state
    const removeData = {
      bookingId: editedBookingLocal.id,
      bookingContainerId: editedBooking.bookingContainerId,
      orderItemId: addedItem.id,
      removedAddOns: editedBookingLocal.removedAddOns,
    } as RemoveFromBookingContainerItem;
    dispatch(removeFromBookingContainerAsync(removeData))
      .then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            const newBookingOrderItems = [
              ...editedBookingLocal.bookingOrderItems,
              addedItem,
            ];

            // Create a new copy of editedBooking and update bookingOrderItems
            const newEditedBooking = {
              ...editedBookingLocal,
              bookingOrderItems: newBookingOrderItems,
              bookingType: editedBookingLocal.bookingType,
            };
            localSetEditedBooking(newEditedBooking);
            const newEditedBookingType = {
              ...findItem[0],
              bookingType: editedBookingLocal.bookingType,
            };
            setEditedBookingLocal(newEditedBookingType);
            setEditedBooking(newEditedBookingType);
            dispatch(setBookingContainer(res.payload.result));
          }
        } else {
          dispatch(
            addStatusToast({
              Message: `Poistaminen epäonnistui${res.payload.message}`,
              IsFailed: true,
              Title: 'Virhe',
            }),
          );
        }
      })
      .finally(() => {
        setshowLoader(false);
      });
  };
  const bookingOrderItems =
    editedBookingLocal?.bookingOrderItems != null ? (
      editedBookingLocal?.bookingOrderItems.map((item, index) => (
        <tr key={item.id}>
          <td>
            {item.addOnNumber !== null && item.addOnNumber > 0
              ? item.addOnNumber
              : ''}{' '}
            {item.accommodationNumber !== undefined &&
              item.accommodationNumber > 0 && (
                <button
                  type="submit"
                  className="booking-link"
                  onClick={e => {
                    e.preventDefault();
                    window.open(
                      `/accommodations/details/${item.accommodationId}`,
                      '_blank',
                      `width=1000,height=1000,scrollbars=yes,resizable=yes,left=${window.screen.width / 2 - 500},top=${window.screen.height / 2 - 500}`,
                    );
                  }}
                >
                  {item.accommodationNumber > 0
                    ? item.accommodationNumber
                    : ''}{' '}
                </button>
              )}
            {item.itemName !== undefined ? item.itemName : ''}
            {item.includedInPrice && (
              <div style={{ color: 'blue' }}>Sisältyy hintaan</div>
            )}
          </td>
          <td>
            {item.ownerAccountId != null && (
              <button
                type="submit"
                className="booking-link"
                onClick={e => {
                  e.preventDefault();
                  window.open(
                    `/users/details/${item.ownerAccountId}`,
                    '_blank',
                    `width=1000,height=1000,scrollbars=yes,resizable=yes,left=${window.screen.width / 2 - 500},top=${window.screen.height / 2 - 500}`,
                  );
                }}
              >
                {item.ownerName}
              </button>
            )}
          </td>
          <td>
            {editedBookingLocal.bookingType !== 5 &&
              editedBookingLocal.bookingType !== 13 && (
                <>
                  {item.startDateTime !== undefined
                    ? new Date(Date.parse(item.startDateTime)).toLocaleString(
                        'fi-FI',
                        {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                        },
                      )
                    : ''}{' '}
                  -{' '}
                  {item.endDateTime !== undefined
                    ? new Date(Date.parse(item.endDateTime)).toLocaleString(
                        'fi-FI',
                        {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                        },
                      )
                    : ''}
                </>
              )}
            {(editedBookingLocal.bookingType === 5 ||
              editedBookingLocal.bookingType === 13) &&
              item.startDateTime !== undefined &&
              item.endDateTime !== undefined && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <DatePicker
                    locale={fi}
                    required
                    dateFormat="dd.MM.yyyy HH:mm"
                    showYearDropdown
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    id={`start-${index}`}
                    onChange={date => handleStartDateChange(date, index)}
                    selected={new Date(item.startDateTime)}
                    className="form-control-small-font"
                  />
                  <span>-</span>
                  <DatePicker
                    locale={fi}
                    required
                    dateFormat="dd.MM.yyyy HH:mm"
                    showYearDropdown
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    id={`end-${index}`}
                    onChange={date => handleEndDateChange(date, index)}
                    selected={new Date(item.endDateTime)}
                    className="form-control-small-font"
                  />
                </div>
              )}
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled={
                item.amountPerQuantity !== true ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              name={index.toString()}
              value={item.units !== undefined ? item.units : ''}
              onChange={handlUnitsChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled={
                item.orderItemType !== 0 ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              name={index.toString()}
              value={
                item.amountOfAdults !== undefined ? item.amountOfAdults : ''
              }
              onChange={handlAdultsChangeRow}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              name={index.toString()}
              disabled={
                item.orderItemType !== 0 ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              value={
                item.amountOfChildren !== undefined ? item.amountOfChildren : ''
              }
              onChange={handlChildChangeRow}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled={
                (editedBooking && editedBooking.crossSiteBooking) ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              name={index.toString()}
              value={
                item.pricesResponse.grossPrice === null ||
                item.pricesResponse.grossPrice === undefined
                  ? ''
                  : String(item.pricesResponse.grossPrice)
              }
              onChange={handlGrosPriceChange}
              className="px-8"
            />
          </td>
          {item.purchasePricesResponse.ownerPurchasePrice > 0 && (
            <td>
              <Form.Control
                type="number"
                name={index.toString()}
                disabled={
                  (editedBooking && editedBooking.crossSiteBooking) ||
                  (editedBookingLocal &&
                    (editedBookingLocal.advanceBilled === null ||
                      editedBookingLocal.advanceBilled === undefined ||
                      editedBookingLocal.advanceBilled === false) &&
                    editedBookingLocal.paymentAmount !== null &&
                    editedBookingLocal.paymentAmount !== undefined &&
                    editedBookingLocal.paymentAmount > 0)
                }
                value={
                  item.purchasePricesResponse.ownerPurchasePrice === null ||
                  item.purchasePricesResponse.ownerPurchasePrice === undefined
                    ? ''
                    : String(item.pricesResponse.grossPrice)
                }
                onChange={handleOwnerPurchsePriceChange}
                className="px-8"
              />
            </td>
          )}
          {item.purchasePricesResponse.ownerPurchasePrice <= 0 && (
            <td>
              <Form.Control
                size="sm"
                type="number"
                name={index.toString()}
                disabled={
                  editedBooking.crossSiteBooking ||
                  (editedBookingLocal &&
                    (editedBookingLocal.advanceBilled === null ||
                      editedBookingLocal.advanceBilled === undefined ||
                      editedBookingLocal.advanceBilled === false) &&
                    editedBookingLocal.paymentAmount !== null &&
                    editedBookingLocal.paymentAmount !== undefined &&
                    editedBookingLocal.paymentAmount > 0)
                }
                value={item.purchasePricesResponse.sitePurchasePrice ?? ''}
                onChange={handleSitePurchsePriceChange}
                className="px-8"
              />
            </td>
          )}
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled={
                item.orderItemType !== 0 ||
                (editedBookingLocal &&
                  (editedBooking.crossSiteBooking ||
                    ((editedBookingLocal.advanceBilled === null ||
                      editedBookingLocal.advanceBilled === undefined ||
                      editedBookingLocal.advanceBilled === false) &&
                      editedBookingLocal.paymentAmount !== null &&
                      editedBookingLocal.paymentAmount !== undefined &&
                      editedBookingLocal.paymentAmount > 0)))
              }
              name={index.toString()}
              value={item.pricesResponse.discountP ?? ''}
              onChange={handlDiscountChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              disabled={
                item.orderItemType !== 0 ||
                editedBooking.crossSiteBooking ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              type="number"
              name={index.toString()}
              value={
                editedBookingLocal != null &&
                editedBookingLocal.overrideTravelCommission != null
                  ? editedBookingLocal.overrideTravelCommission
                  : (item.pricesResponse.travelAgencyComissionP ?? '')
              }
              onChange={handlTravelPChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              disabled
              type="number"
              name={index.toString()}
              value={item.pricesResponse.discount ?? ''}
              onChange={handlTravelPChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              disabled
              type="number"
              name={index.toString()}
              value={item.pricesResponse.sellerCommission ?? ''}
              onChange={handlTravelPChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              disabled
              type="number"
              name={index.toString()}
              value={item.pricesResponse.travelAgencyComission ?? ''}
              onChange={handlTravelPChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              disabled
              type="number"
              name={index.toString()}
              value={item.pricesResponse.netPrice ?? ''}
              className="px-8"
            />
          </td>
          <td>
            {editedBookingLocal.isAllowedToCancel === true &&
              editedBookingLocal.isAllowedToEdit === true && (
                <Button
                  size="sm"
                  variant="danger"
                  disabled={
                    ((editedBookingLocal &&
                      editedBookingLocal.advanceBilled === null) ||
                      editedBookingLocal.advanceBilled === undefined ||
                      editedBookingLocal.advanceBilled === false) &&
                    editedBookingLocal &&
                    editedBookingLocal.paymentAmount !== null &&
                    editedBookingLocal.paymentAmount !== undefined &&
                    editedBookingLocal.paymentAmount > 0
                  }
                  name={index.toString()}
                  onClick={handleRemoveFromContainer}
                  className="w-100"
                >
                  Poista
                </Button>
              )}
          </td>
        </tr>
      ))
    ) : (
      <tr />
    );
  return (
    <Modal
      show={showNewBookingModal}
      onHide={() => handleCloseBooking}
      backdrop="static"
      fullscreen
      keyboard={false}
      size="xl"
    >
      <Modal.Header>
        <div>
          <Modal.Title>
            {'Korissa olevan varauksen muokkaus: '}
            {editedBookingLocal !== null &&
            editedBookingLocal.bookingNumber === 0
              ? ' Vahvistamaton'
              : editedBookingLocal?.bookingNumber}
          </Modal.Title>
          {editedBookingLocal !== undefined &&
            editedBookingLocal !== null &&
            editedBookingLocal.bookingType !== undefined &&
            editedBookingLocal.bookingType !== null &&
            (editedBookingLocal.payerId === null ||
              editedBookingLocal.payerId === undefined) &&
            (editedBookingLocal.bookingType === 0 ||
              editedBookingLocal.bookingType === 5 ||
              editedBookingLocal.bookingType === 13) && (
              <div>
                <h4>Uusi varaustyyppi: </h4>
                <Select
                  inputId="bookingType"
                  name="bookingType"
                  placeholder="Valitse varaustyyppi"
                  onChange={option =>
                    handleSelectChangeBookingType(option, 'bookingType')
                  }
                  isClearable
                  isSearchable
                  options={getAllowedBookingTypesPreliminary()}
                  value={bookingTypeItems.filter(
                    option =>
                      option.value ===
                      (editedBookingLocal !== undefined &&
                      editedBookingLocal !== null
                        ? editedBookingLocal.bookingType
                        : 0),
                  )}
                />
              </div>
            )}
          {editedBookingLocal !== undefined &&
            editedBookingLocal !== null &&
            editedBookingLocal.bookingType !== undefined &&
            editedBookingLocal.bookingType !== null &&
            (editedBookingLocal.payerId === null ||
              editedBookingLocal.payerId === undefined) &&
            (editedBookingLocal.bookingType === 5 ||
              editedBookingLocal.bookingType === 13) &&
            !editedBooking.ownSiteAccommodation && (
              <div>
                <h4 className="text-danger">
                  Omistajan omavarauksen voi tehdä vain kohteen omassa
                  varaamossa!{' '}
                </h4>
              </div>
            )}
          {editedBooking !== null &&
            editedBooking.bookingType !== 5 &&
            editedBooking.bookingType !== 13 &&
            editedBooking.payerId !== null &&
            editedBooking.payerId !== undefined &&
            editedBooking.payerId !== 'undefined' && (
              <div>
                <h4>Uusi varaustyyppi: </h4>
                <Select
                  inputId="bookingType"
                  name="bookingType"
                  placeholder="Valitse varaustyyppi"
                  onChange={option =>
                    handleSelectChangeBookingType(option, 'bookingType')
                  }
                  isClearable
                  isSearchable
                  options={getAllowedBookingTypes()}
                  value={bookingTypeItems.filter(
                    option =>
                      option.value ===
                      (editedBookingLocal !== undefined &&
                      editedBookingLocal !== null
                        ? editedBookingLocal.bookingType
                        : 0),
                  )}
                />
              </div>
            )}
          {editedBookingLocal !== null &&
            editedBookingLocal !== undefined &&
            editedBookingLocal.bookingType === 0 && (
              <div style={{ maxWidth: 400 }}>
                {editedBooking && editedBooking.errors && (
                  <span className="text-danger">
                    {Object.entries(editedBooking.errors).map(
                      ([key, value], index) => (
                        <React.Fragment key={`error-${key}`}>
                          {Array.isArray(value) ? value.join(', ') : value}
                          <br />
                        </React.Fragment>
                      ),
                    )}
                  </span>
                )}
                {!editedBookingLocal.preliminaryBookingDueDate && (
                  <small className="text-danger mt-1 d-block">
                    Valitse alustavan varauksen viimeinen voimassaolopäivä
                  </small>
                )}
                <Heading
                  Level={5}
                  Title="Alustavan varauksen viimeinen voimassaolopäivä"
                />
                <DatePicker
                  locale={fi}
                  required
                  dateFormat="dd.MM.yyyy HH:mm"
                  showTimeSelect
                  showYearDropdown
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Time"
                  id={editedBookingLocal.id}
                  onChange={date => handleDueDateDateChange(date, 0)}
                  selected={(() => {
                    if (editedBookingLocal.preliminaryBookingDueDate) {
                      const parsedDate = new Date(
                        editedBookingLocal.preliminaryBookingDueDate,
                      );
                      return !Number.isNaN(parsedDate.getTime())
                        ? parsedDate
                        : null;
                    }
                    return null;
                  })()}
                  popperPlacement="bottom-start"
                  className={`form-control-small-font offcanvas-width-xl ${
                    editedBookingLocal.preliminaryBookingDueDate === null ||
                    editedBookingLocal.preliminaryBookingDueDate ===
                      undefined ||
                    editedBookingLocal.preliminaryBookingDueDate === ''
                      ? 'border-danger'
                      : ''
                  }`}
                />
              </div>
            )}
          {editedBooking !== null &&
            editedBooking !== null &&
            editedBooking.bookingType === 15 && (
              <Alert variant="primary" className="mt-16">
                Huom!, Luonnostilainen varaus ei varaa kapasiteettia.
                Luonnostilaisen varauksen voi tallentaa vain alustavaksi
                varaukseksi, jolloin kapasiteetti lukittuu.
              </Alert>
            )}
        </div>
      </Modal.Header>
      <Modal.Body className="px-24 py-24 px-lg-40">
        <Loader IsLoading={showLoader} />
        <div className="text-end d-flex flex-column flex-sm-row gap-8 justify-content-end mb-16">
          {editedBookingLocal !== null &&
          editedBookingLocal.bookingType === 0 &&
          editedBookingLocal.payerId === null ? (
            <Button
              variant="link"
              onClick={localedited =>
                handleShowCloseConfirmation(editedBookingLocal)
              }
            >
              Sulje
            </Button>
          ) : (
            <Button
              variant="link"
              onClick={localedited => handleJustClose(editedBookingLocal)}
            >
              Sulje
            </Button>
          )}
          {makingOwnerBooking === false && (
            <>
              <Button
                size="sm"
                variant="outline-blue"
                onClick={() => updateBookingContainer()}
              >
                Päivitä
              </Button>
              {!showLoader &&
                editedBookingLocal !== null &&
                editedBookingLocal !== undefined &&
                ((editedBookingLocal.byPassAdvanceSum &&
                  editedBookingLocal.errors.length > 0) ||
                  editedBookingLocal.errors.length <= 0) &&
                ((editedBookingLocal.byPassSellPriceCheck &&
                  editedBookingLocal.errors.length > 0) ||
                  editedBookingLocal.errors.length <= 0) &&
                editedBookingLocal.bookingType !== 9 &&
                editedBookingLocal.bookingType !== 3 &&
                editedBookingLocal.bookingType !== 7 &&
                editedBookingLocal.bookingType !== 7 &&
                editedBookingLocal.bookingType !== 11 &&
                editedBookingLocal.bookingType !== 14 &&
                editedBookingLocal.bookingType !== 15 &&
                editedBookingLocal.bookingType !== 0 &&
                editedBookingLocal.payerId !== null &&
                editedBookingLocal.payerId !== undefined && (
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => confirmBooking()}
                  >
                    Vahvista varaus
                  </Button>
                )}
            </>
          )}
          {makingOwnerBooking === false &&
            editedBookingLocal !== null &&
            editedBookingLocal !== null &&
            editedBookingLocal.bookingType === 0 &&
            editedBookingLocal.payerId !== null &&
            editedBookingLocal.payerId !== undefined && (
              <Button
                size="sm"
                variant="primary"
                onClick={() => updateBookingContainerAndClose()}
              >
                Vahvista varaus
              </Button>
            )}
          {makingOwnerBooking === true &&
            editedBookingLocal !== null &&
            editedBookingLocal !== null &&
            (editedBookingLocal.bookingType === 5 ||
              editedBookingLocal.bookingType === 13) && (
              <Button
                size="sm"
                variant="primary"
                onClick={saveOwnerOwnBooking}
                disabled={isAvailCheckActive}
              >
                Vahvista Omistajan omavaraus
              </Button>
            )}
          {makingOwnerBooking === true &&
            editedBookingLocal !== null &&
            editedBookingLocal !== null &&
            isAvailCheckActive &&
            (editedBookingLocal.bookingType === 5 ||
              editedBookingLocal.bookingType === 13) && (
              <Button size="sm" variant="primary" onClick={checkAvailability}>
                Tarkista saatavuus
              </Button>
            )}
          {editedBookingLocal !== null &&
            editedBookingLocal !== undefined &&
            editedBookingLocal.bookingType === 15 && (
              <Button
                size="sm"
                variant="primary"
                onClick={() => handleUpdateToPleriminaryBooking()}
              >
                Tallenna alustavaksi varaukseksi
              </Button>
            )}
        </div>
        <Heading Level={4} Title="Palvelut korissa" />
        {editedBooking !== null &&
          editedBooking !== undefined &&
          editedBooking.accommodationReclamationText && (
            <Alert className="mb-32">
              <div>Huomioitavaa:</div>
              {editedBooking.accommodationReclamationText ?? ''}
            </Alert>
          )}
        {editedBooking !== null &&
          editedBooking !== undefined &&
          editedBooking.errors &&
          editedBooking.errors.length > 0 && (
            <>
              <Alert className="alert-danger">
                <div>Virhe:</div>
                {editedBooking.errors ?? ''}
              </Alert>
              {editedBookingLocal && editedBookingLocal.errors && (
                <>
                  {/* Checkbox for advance payment not allowed error */}
                  {(Object.values(editedBookingLocal.errors).some(value =>
                    Array.isArray(value)
                      ? value.some(v => v.includes('Ostohinnat'))
                      : value.includes('suuremmat'),
                  ) ||
                    editedBookingLocal.byPassAdvanceSum === true) && (
                    <Form.Group className="mt-3">
                      <Form.Check
                        type="checkbox"
                        id="pricePaymentOverrideCheckbox"
                        label="Ohita Myyntihinnan tarkistus"
                        onChange={handlAllowPriceByPassChange}
                        checked={editedBookingLocal.byPassSellPriceCheck}
                      />
                    </Form.Group>
                  )}
                </>
              )}
            </>
          )}
        <div className="table-responsive-lg mb-48">
          <Table className="table-data table-wrap mt-16 mb-32">
            <thead>
              <tr key="headerBooking">
                <th style={{ width: '150px' }}>Palvelu</th>
                <th style={{ width: '150px' }}>Omistaja/Huoltaja</th>
                <th style={{ width: '190px' }}>Kesto</th>
                <th style={{ width: '70px' }}>Määrä</th>
                <th style={{ width: '50px' }}>Aikuisia</th>
                <th style={{ width: '70px' }}>Lapsia</th>
                <th style={{ width: '100px' }}>Hinta</th>
                <th style={{ width: '100px' }}>Ostohinta</th>
                <th style={{ width: '70px' }}>Alennus %</th>
                <th style={{ width: '70px' }}>Matk.Prov.%</th>
                <th style={{ width: '70px' }}>Alennus</th>
                <th style={{ width: '100px' }}>Myyntipalkkio</th>
                <th style={{ width: '100px' }}>Matk.Prov</th>
                <th style={{ width: '100px' }}>Loppuhinta</th>
                <th style={{ width: '70px' }}>Toiminto</th>
              </tr>
            </thead>
            <tbody>{bookingOrderItems}</tbody>
          </Table>
          {editedBooking && (
            <div style={{ textAlign: 'right' }} className="fw-bold large ">
              <span style={{ textAlign: 'right' }}>Kokonaishinta:</span>{' '}
              {editedBooking.netPrice}€
            </div>
          )}
          {makingOwnerBooking === false && (
            <div>
              <Heading Level={4} Title="Valittavissa olevat lisäpalvelut" />
              <Table className="table table-data table-wrap mt-16 mb-32">
                <thead>
                  <tr key="headExtra">
                    <th>Palvelu</th>
                    <th>Kesto</th>
                    <th>Määrä</th>
                    <th>Aikuisia</th>
                    <th>Lapsia</th>
                    <th>Hinta/yksikkö</th>
                    <th>Ostohinta/yksikkö</th>
                    <th>Alennus %</th>
                    <th>Matk.Prov.%</th>
                    <th>Toiminto</th>
                  </tr>
                </thead>
                <tbody>{selectableAddOnItems}</tbody>
              </Table>
            </div>
          )}
        </div>
        <div>
          {editedBookingLocal !== undefined && editedBookingLocal !== null && (
            <div>
              <Row xs={1} lg={2} className="gx-40 gy-24">
                <Col>
                  {makingOwnerBooking === true && (
                    <div>
                      <Form.Group>
                        <Form.Label>Palvelut</Form.Label>
                        <Form.Check
                          label="Loppusiivous"
                          className="mb-8"
                          id="finalcleaning"
                          onChange={() => setCleaningChecked(!cleaningChecked)}
                        />
                        <Form.Check
                          label="Liinavaatteet"
                          onChange={() => setLinenChecked(!linenChecked)}
                          id="lining"
                        />
                      </Form.Group>
                      {/* <Form.Group> */}
                      {/*  <h6>Valitse Omavarauksen tyyppi:</h6> */}
                      {/*  <Form.Select */}
                      {/*    onChange={e => setOwnerOwnBookingType(e.target.value)} */}
                      {/*    defaultValue="OwnerOwn" */}
                      {/*    value={ownerOwnBookingType ?? ''} */}
                      {/*  > */}
                      {/*    <option value="OwnerOwn">Omakäyttö</option> */}
                      {/*    <option value="TemporaryDisabled"> */}
                      {/*      Väliaikainen myynnistä poisto */}
                      {/*    </option> */}
                      {/*    /!* <option value="Maintenance">Huoltokäynti</option> *!/ */}
                      {/*  </Form.Select> */}
                      {/* </Form.Group> */}
                    </div>
                  )}
                  {editedBookingLocal && editedBookingLocal.errors && (
                    <>
                      {/* Checkbox for advance payment not allowed error */}
                      {(Object.values(editedBookingLocal.errors).some(value =>
                        Array.isArray(value)
                          ? value.some(v => v.includes('Ennakko'))
                          : value.includes('Ennakko'),
                      ) ||
                        editedBookingLocal.byPassAdvanceSum === true) && (
                        <Form.Group className="mt-3">
                          <Form.Check
                            type="checkbox"
                            id="advancePaymentOverrideCheckbox"
                            label="Ohita ennakkomaksurajoitus"
                            onChange={handlAllowAdvanceByPassChange}
                            checked={editedBookingLocal.byPassAdvanceSum}
                          />
                        </Form.Group>
                      )}
                    </>
                  )}
                  {editedBookingLocal && (
                    <div>
                      <Heading Level={5} Title="Ennakkolaskun eräpäivä" />
                      <DatePicker
                        locale={fi}
                        required
                        dateFormat="dd.MM.yyyy"
                        disabled={
                          editedBookingLocal.paymentAmount !== null &&
                          editedBookingLocal.paymentAmount > 0
                        }
                        showYearDropdown
                        id={editedBookingLocal.id}
                        onChange={date =>
                          handleAdvanceInvoiceDueDateDateChange(date, 0)
                        }
                        selected={(() => {
                          if (
                            editedBookingLocal.advanceBillPrice > 0 &&
                            editedBookingLocal.advanceInvoiceDueDate
                          ) {
                            const parsedDate = new Date(
                              editedBookingLocal.advanceInvoiceDueDate,
                            );
                            return !Number.isNaN(parsedDate.getTime())
                              ? parsedDate
                              : null;
                          }
                          return null;
                        })()}
                        className="form-control-small-font offcanvas-width-xl"
                      />
                      <Heading Level={5} Title="Loppulaskun eräpäivä" />
                      <DatePicker
                        locale={fi}
                        required
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown
                        disabled={
                          editedBookingLocal &&
                          (editedBookingLocal.advanceBilled === null ||
                            editedBookingLocal.advanceBilled === undefined ||
                            editedBookingLocal.advanceBilled === false) &&
                          editedBookingLocal.paymentAmount !== null &&
                          editedBookingLocal.paymentAmount > 0
                        }
                        id={editedBookingLocal.id}
                        onChange={date =>
                          handleFinalInvoiceDueDateDateChange(date, 0)
                        }
                        selected={(() => {
                          if (editedBookingLocal.finalInvoiceDueDate) {
                            const parsedDate = new Date(
                              editedBookingLocal.finalInvoiceDueDate,
                            );
                            return !Number.isNaN(parsedDate.getTime())
                              ? parsedDate
                              : null;
                          }
                          return null;
                        })()}
                        className="form-control-small-font offcanvas-width-xl"
                      />
                    </div>
                  )}
                  {makingOwnerBooking === false &&
                    editedBookingLocal.payerId !== null &&
                    editedBookingLocal.payerId !== undefined &&
                    editedBookingLocal.payerId !== '' && (
                      <div>
                        <h5 className="mt-16">Ennakkomaksun määrä: </h5>
                        <Form.Control
                          disabled={editedBookingLocal.paymentAmount > 0}
                          type="number"
                          name={editedBookingLocal.toString()}
                          value={
                            getAdvanceValueToShow() <= 0
                              ? 0
                              : getAdvanceValueToShow()
                          }
                          onChange={handlAdvanceBillPriceChange}
                        />
                      </div>
                    )}
                </Col>
                <Col>
                  {makingOwnerBooking === false && (
                    <div>
                      <div className="d-flex align-items-start mt-48">
                        {selectedPayer !== null && (
                          <h5 className="h5 h-md-4 flex-grow-0 me-16 mb-24">
                            Valittu maksaja
                          </h5>
                        )}
                        <Button
                          variant="outline-blue"
                          onClick={() => selectPayer()}
                          size="sm"
                        >
                          {selectedPayer !== null
                            ? 'Vaihda maksaja'
                            : 'Valitse maksaja'}
                        </Button>
                      </div>
                      {checkPayerData() === true && (
                        <Alert
                          variant="danger"
                          className="h5 h-md-4 flex-grow-0 me-16 mb-24"
                        >
                          Tiedot ovat muuttuneet
                        </Alert>
                      )}
                      {selectedPayer !== null && selectedPayer !== null && (
                        <div>
                          <div>
                            {selectedPayer.firstName} {selectedPayer.lastName}
                          </div>
                          {selectedPayer !== null &&
                            selectedPayer !== null &&
                            selectedPayer.addresses != null && (
                              <div>
                                <div>
                                  {selectedPayer.addresses[0] &&
                                    selectedPayer.addresses[0]
                                      .postStreetAddress &&
                                    selectedPayer.addresses[0]
                                      .postStreetAddress}
                                </div>
                                <div>
                                  {selectedPayer.addresses[0] &&
                                    selectedPayer.addresses[0].postCode &&
                                    selectedPayer.addresses[0].postCode}{' '}
                                  {selectedPayer.addresses[0] &&
                                    selectedPayer.addresses[0].postCity &&
                                    selectedPayer.addresses[0].postCity}
                                </div>
                              </div>
                            )}
                          {selectedPayer !== null &&
                            selectedPayer !== null &&
                            selectedPayer.phones != null && (
                              <div>
                                {selectedPayer.phones[0] !== undefined &&
                                selectedPayer.phones[0] !== null
                                  ? selectedPayer.phones[0].phoneNumber
                                  : ''}
                              </div>
                            )}
                          {selectedPayer !== null &&
                            selectedPayer !== null &&
                            selectedPayer.emails != null && (
                              <div>
                                {selectedPayer.emails[0] !== undefined &&
                                selectedPayer.emails[0] !== null
                                  ? selectedPayer.emails[0].emailAddress
                                  : ''}
                              </div>
                            )}
                        </div>
                      )}
                      {webshopCustomer !== undefined &&
                        webshopCustomer !== null && (
                          <>
                            <h5 className="mt-24">
                              Verkkokaupan asiakastiedot:{' '}
                            </h5>
                            <div>
                              {webshopCustomer.firstName}{' '}
                              {webshopCustomer.lastName}
                            </div>
                            <div>{webshopCustomer.companyName}</div>
                            <div>
                              {webshopCustomer.streetAddress}{' '}
                              {webshopCustomer.additionalInformation}
                            </div>
                            <div>
                              {webshopCustomer.postalCode}{' '}
                              {webshopCustomer.postCity}
                            </div>
                            <div>{webshopCustomer.phoneNumber}</div>
                            <div>{webshopCustomer.email}</div>
                          </>
                        )}
                    </div>
                  )}
                </Col>
              </Row>
              {makingOwnerBooking === false && (
                <>
                  <hr className="mt-32 mb-24" />
                  <Row className="gx-40 gy-24">
                    <Col lg={8} xl={6}>
                      <div className="d-flex align-items-start">
                        <h5 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                          Asiakkaan lisätiedot
                        </h5>
                        <Button
                          variant="primary"
                          onClick={handleAddCustomerBookingNote}
                          disabled={editedCustomerBookingNotes.length > 0}
                          size="sm"
                        >
                          Lisää asiakaskommentti
                        </Button>
                      </div>
                      {editedCustomerBookingNotes.map((noteItem, noteIndex) => (
                        <div key={`customer-note-${noteItem.id}`}>
                          <Form.Control
                            as="textarea"
                            name={`${noteIndex.toString()}`}
                            value={noteItem.noteText ?? ''}
                            onChange={handlCustomerCommentChange}
                            ref={el => setRef(el, noteIndex)}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                </>
              )}
              <hr className="mt-32 mb-24" />
              <Row className="gx-40 gy-24">
                <Col lg={8} xl={6}>
                  <div className="d-flex align-items-start">
                    <h5 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                      Omistajan lisätiedot
                    </h5>
                    <Button
                      variant="primary"
                      onClick={handleAddOwnerBookingNote}
                      disabled={editedOwnerBookingNotes.length > 0}
                      size="sm"
                    >
                      Lisää omistajakommentti
                    </Button>
                  </div>
                  {editedOwnerBookingNotes.map((noteItem, noteIndex) => (
                    <div key={`owner-note-${noteItem.id}`}>
                      <Form.Control
                        as="textarea"
                        name={`${noteIndex.toString()}`}
                        value={noteItem.noteText ?? ''}
                        onChange={handlOwnerCommentChange}
                        ref={el => setOwnerRef(el, noteIndex)}
                      />
                    </div>
                  ))}
                </Col>
              </Row>
              {makingOwnerBooking === false && (
                <>
                  <hr className="mt-32 mb-24" />
                  <Row className="gx-40 gy-24">
                    <Col lg={8} xl={6}>
                      <div className="d-flex align-items-start">
                        <h5 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                          Virkailijan lisätiedot
                        </h5>
                        <Button
                          variant="primary"
                          onClick={handleAddOfficerBookingNote}
                          disabled={editedOfficerBookingNotes.length > 0}
                          size="sm"
                        >
                          Lisää virkailija kommentti
                        </Button>
                      </div>
                      {editedOfficerBookingNotes.map((noteItem, noteIndex) => (
                        <div key={`officer-note-${noteItem.id}`}>
                          <Form.Control
                            as="textarea"
                            name={`${noteIndex.toString()}`}
                            value={noteItem.noteText ?? ''}
                            onChange={handlOfficerCommentChange}
                            ref={el => setOfficerRef(el, noteIndex)}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                </>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* {editedBookingLocal !== null && */}
        {/*  editedBookingLocal !== undefined && */}
        {/*  editedBookingLocal.isAllowedToEdit === true && ( */}
        {/*    <Button variant="primary" onClick={() => handleSaveBooking()}> */}
        {/*      Tallenna */}
        {/*    </Button> */}
        {/*  )} */}
      </Modal.Footer>
      <Modal
        show={showCloseConfirmation}
        onHide={handleCancelClose}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Vahvista toiminto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Maksajaa ei ole valittu. Perutaanko varaus ja suljetaanko ikkuna?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelClose}>
            Palaa valitsemaan maksaja
          </Button>
          <Button variant="primary" onClick={handleConfirmClose}>
            Peruuta Varaus
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showDueDateConfirmation}
        onHide={handleCancelClose}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title>Virhe</Modal.Title>
        </Modal.Header>
        <Modal.Body>Alustavan varauksen voimassaolo puuttuu</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSetDueDateClose}>
            Palaa Asettamaan viimeinen voimassaolopäivä
          </Button>
        </Modal.Footer>
      </Modal>
    </Modal>
  );
};
